module.exports = __webpack_public_path__ + "img/vessel.b52d3aa3.jpeg";